import React, { FC, useEffect, useState, useRef } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import TopBlock from './TopBlock';
import { RootStoreType } from 'src/types/store';
import { allColumns } from './constants';
import TableSimple from 'src/components/TableSimple';
import { ExportTypeType, TableRefType } from 'src/types/table';
import { useCheckPermission } from 'src/utils/checkPermission';
import StoreIcon from '@mui/icons-material/Store';
import { getProviderTransferCompaniesListFetch } from 'src/resources/providerTransferCompaniesList/reducer';

const ProviderTransferCompaniesListContainer: FC = (props) => {
    const dispatch = useDispatch();
    const tableRef = useRef<TableRefType>();
    const [activeTab, setActiveTab] = useState<string>('providerTransferCompanies');

    const loading = useSelector((state: RootStoreType) => state.providerTransferCompaniesList.loading);
    const providerTransferCompaniesData = useSelector((state: RootStoreType) => state.providerTransferCompaniesList.data);

    const permissionCreate = useCheckPermission('PROVIDER_TRANSFER_COMPANY.CREATE');
    const permissionDetail = useCheckPermission('PROVIDER_TRANSFER_COMPANY.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('providerTransferCompanies.title') }));
        dispatch(getProviderTransferCompaniesListFetch());
    }, []);

    const reloadProviderTransferCompaniesList = () => {
        dispatch(activeTab === 'providerTransferCompanies' ? getProviderTransferCompaniesListFetch() : getProviderTransferCompaniesListFetch());
    };

    const handleExport = (type: ExportTypeType) => {
        tableRef.current?.exportTable(type, translate('providerTransferCompanies.action.exportFileName'));
    };

    return (
        <>
            <TopBlock
                reloadProviderTransferCompaniesList={reloadProviderTransferCompaniesList}
                permissionCreate={permissionCreate}
                handleExport={handleExport}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
            <TableSimple
                tableRef={tableRef}
                rowIdKey="ID"
                rows={providerTransferCompaniesData || []}
                loading={loading}
                columsLabelPrefix="providerTransferCompanies.table"
                allColumns={allColumns}
                initSort={{ column: 'ID', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <StoreIcon />,
                        label: translate('providerTransferCompanies.action.providerTransferCompanyDetail'),
                        getLink: (row) => `/settings/provider_transfer_companies/${row.ID}/`,
                        hiddenFce: () => !permissionDetail,
                    },
                ]}
                selectOptions={{}}
                heightVariant="top-tab"
                fullHeight
                optionsSessionName="providerTransferCompaniesTable"
            />
        </>
    );
};

export default ProviderTransferCompaniesListContainer;
